import { usePortalData } from '../data/usePortalData';
export const useConfiguredColumnLabelOverride = propertyName => {
  var _data$configuredTicke;
  const {
    data
  } = usePortalData();
  return data === null || data === void 0 || (_data$configuredTicke = data.configuredTicketProperties.find(column => column.propertyName === propertyName)) === null || _data$configuredTicke === void 0 ? void 0 : _data$configuredTicke.displayNameOverride;
};